import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListMeetingPayload } from '@app-store/slices/meetings/list'

interface TaskAction extends Action {
    payload: IListMeetingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.list

function* listMeetingSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/meeting`, {
            params
        })
        if (response.success) {
            yield put(onSuccess({ noSaveInStore: payload.noSaveInStore, ...response.result }))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listMeetingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listMeetingSagaTask)
}

export default listMeetingSaga
